import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { getThreadStatusText, isThreadOnline, parseISODate } from 'app/@chat/utils/utils';
import {
  TutorialData,
  TutorialIDs,
} from 'app/@core/interfaces/common/CalorieFriend/tutorial';
import { ViewCell } from 'ng2-smart-table';
import { JoyrideService } from 'ngx-joyride';
import { interval } from 'rxjs';

/**
 * Component to represent the custom Patient Name field on the ng2 smart table
 */
@Component({
  template: `
    <div
      class="patientname-container"
      [class.demo-patient]="rowData.isDemoPatient"
      title="Welcome to TrainerFriend"
      [joyrideStep]="TutorialIDs.DemoPatient"
      [stepContent]="customPatientTutorialContent"
      [nextTemplate]="nextButton"
      (next)="onTutorialNext()"
    >
      <ng-template #nextButton>
        <button class="joyride-button">NEXT</button>
      </ng-template>

      <div class="gender-image">
        <nb-user
          [ngClass]="{
            'nb-user': true,
            online: isThreadOnline(rowData?.chatThread),
            offline: !isThreadOnline(rowData?.chatThread)
          }"
          class="nb-user online"
          (click)="onClickLink()"
          name="{{ rowData.name }}"
          onlyPicture
        >
        </nb-user>
      </div>
      <div class="name-and-email">
        <div class="name">
          <a
            class="patient-name"
            href="javascript:void(0)"
            (click)="onClickLink()"
            >{{ rowData.name }}</a
          >
          <span
            i18n="@@TryMe"
            *ngIf="rowData.isDemoPatient"
            class="patient-try-me"
            >Try me!</span
          >
        </div>
        <div class="last-seen-status" (click)="onClickLink()">
          {{ getThreadStatusText(rowData.chatThread, false) }}
        </div>
        <div *ngIf="rowData.hasAppInstalled" class="app-install-status">
          <i class="fas fa-mobile-alt"></i>
          <i class="far fa-check-circle" style="margin-left:3px;"></i>
          &nbsp;App Installed!
        </div>
      </div>
    </div>
    <ng-template #customPatientTutorialContent>
      <span class="tutorial-content" i18n="@@PatientTutorialContent"
        >This is your client’s list. We added a Demo Client so you can test all
        features easily. Once you are comfortable, simply delete it using the
        trash can.</span
      >
    </ng-template>
  `,
  styleUrls: ['./CustomPatientNameField.component.scss'],
  selector: 'app-custom-patient-name',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomPatientNameFieldComponent implements ViewCell {
  @Input() value: any; // This hold the cell value
  @Input() rowData: any; // This holds the entire row object

  public constructor(
    private router: Router,
    private tutorialService: TutorialData,
    private joyride: JoyrideService,
    private detectorRef: ChangeDetectorRef
  ) {
    
    interval(30 * 1000).subscribe(() => {
      this.detectorRef.markForCheck();
    });
  }

  /**
   * Event handler of 'Click' event of the link.
   * It navigates to the Patient Sheet View page of the Patient of the current row
   */
  onClickLink() {
    if (this.joyride.isTourInProgress()) return;
    this.router.navigate([
      `/pages/CalorieFriend/PatientSheetView/${this.rowData.id}`,
    ]);
  }

  onTutorialNext() {
    this.tutorialService.save(TutorialIDs.DemoPatient).subscribe(() => {});
  }

  TutorialIDs = TutorialIDs;

  readonly getThreadStatusText = getThreadStatusText;
  readonly isThreadOnline = isThreadOnline;
}
